import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const DeleteConfirmDialog = ({
  openConfirm,
  setOpenConfirm,
  deleteGameHandler,
}) => {
  return (
    <Dialog
      open={openConfirm}
      onClose={() => setOpenConfirm(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to delete question?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          All cards with this question would be affected.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>

        <Button onClick={() => deleteGameHandler(true)} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
